import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { withBox } from 'components/Box'

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>

interface FormLabelProps extends LabelProps {
  children: ReactNode
  after?: ReactNode
}

const FormLabel: FC<FormLabelProps> = ({ children, after, ...props }) => (
  <label {...props}>
    {children}
    {after}
  </label>
)

const StyledFormLabel = styled(withBox(FormLabel))(
  ({ theme }) => css`
    display: block;

    /* 6px space  does not exist in our space token array */
    /* stylelint-disable-next-line scales/space */
    margin-bottom: 6px;

    color: ${theme.colors.foreground.secondary[3]};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeights.regular};
    line-height: ${theme.lineHeights[3]};
  `
)

export default StyledFormLabel
